module.exports = __webpack_public_path__ + "static/img/bg-overview@m.af61c65.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/omron-healthcare/bg-overview@m.jpg
// module id = rsC3
// module chunks = 0